namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmTypDokumentu extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmTypDokumentuReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmTypDokumentuObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmTypDokumentuObj());
            this.detailObj.createBase({
                contentName: "detailAdmTypDokumentu",
                contentCaption: "jres:32131067",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmTypDokumentu", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmTypDokumentuObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmTypDokumentuReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0}".format((this.data.nazev) ? this.data["stat"] : "")
        }

        setSxsDetail(): string {
            return "{0}".format((this.data.ixs_typ) ? this.data.ixs_typ : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmTypDokumentuSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmTypDokumentu.upsert({ data: data }).get() as any).done((output) => {
                Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderSslstyp");
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmTypDokumentu", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdmTypDokumentu.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                "actOpenSeznamAdmVlastnostObecnyObjekt*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {
            if (editMode == true)
                this.cnt.findFields("Strediska").gfield("enable")
            else
                this.cnt.findFields("Strediska").gfield("disable")
        }

        createForm() {
            var _this = this;
            this.form.form.layoutDescriptor = "L2M2S1"
            this.MakeSection("");
            this.MakeField("ico");
            this.MakeField("ixs_typ");
            this.MakeSelectField("ktg_typ", Gordic.Prefabs.Select.ginckat(), { model: "model.ktg_typ=value.ktg_typ" });
            this.MakeField("nazev");
            this.MakeField("ofic_nazev");
            this.MakeField("zkratka");
            this.MakeField("poznamka");
            this.MakeField("popis");
            this.MakeBoolField("priz_default")
            this.MakeBoolField("s_gen_cj");
            this.MakeField("lhuta_vyr");
            this.MakeSelectField("st_utaj_id", Gordic.Prefabs.Select.gincstu());
            this.MakeSelectField("ixs_ulz", Gordic.Prefabs.Select.wflsulz(), { model: "model.ixs_ulz=value.ixs_ulz" });
            this.MakeSelectField("aktivita_ssl", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita_ssl=value.aktivita" });
            this.MakeSelectField("spis_pl", Gordic.Prefabs.Select.sslsspl(),  // JKLUSACEK - na ��dost pjurika zru�eny omezen� na v�b�r spisov�ho pl�nu a znaku
                {
                    model: "model.spis_pl=value.spis_pl",
                }
            );
            this.MakeSelectField("spis_znak", Gordic.Prefabs.Select.sslsspz(),
                {
                    model: "model.spis_pl=>value.spis_pl,model.spis_znak=value.spis_znak",
                    serverFilters: {
                        spis_pl: new Gordic.Forms.Dependency("spis_pl", "spis_pl", true, false, this.cnt.element)
                    }
                }
            );
            this.MakeSelectField("ixs_esu", Gordic.Prefabs.Select.ginsesu(), { model: "model.ixs_esu=value.ixs_esu" });
            this.MakeSelectField("priz_vycet", Gordic.Prefabs.Select.gincpan(), {
                change: (ev, obj) => {
                    if (obj.value) {
                        if (!Array.isArray(obj.value)) {
                            this.HideField("Strediska")
                            if (obj.value.priz_an == 1)
                                this.ShowField("Strediska")
                        }
                    }
                },
                model: "model.priz_vycet=value.priz_an"
            });
            this.form.addRow("jres:33000101").addField("gselectbox", Gordic.Prefabs.Select.ginstre(), {
                multi: true,
                name: "Strediska",
                itemWidth: "",
                disabled: true,
                serverFilters: {
                    ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element)
                },
                model: function (operation, dto, modelOptions) {
                    switch (operation) {
                        case "apply":
                            var val: any[] = [];
                            if (dto["Strediska"])
                                for (var k in dto["Strediska"]) val.push({ ixs_tre: dto["Strediska"][k]["ixs_tre"] })
                            $(this).gfield("setValue", val, { valid: false });
                            return;
                        case "collect":
                            var strediska: Gordic.AdmIsl.Interface.GAdmTypDokumentuStrediskoSpisovychUzluSaveDto[] = [];
                            var values = $(this).gfield("getValue");
                            values.forEach((item) => {
                                strediska.push({
                                    ixs_tre: item.ixs_tre,
                                    ixs_typ: _this.data.ixs_typ,
                                    aktivita: 100,
                                    poznamka: ""
                                })
                            })
                            dto["Strediska"] = strediska;
                            return;
                    }
                }
            })
            this.MakeSection("");
            this.MakeSelectField("priz_rsp", Gordic.Prefabs.Select.wflcpsp(), { model: "model.priz_rsp=value.priz_rsp" });
            this.MakeBoolField("priz_epk");
            this.MakeField("predpl_vec");
            this.MakeSelectField("typ_vazby", Gordic.Prefabs.Select.wflctyv(), { model: "model.typ_vazby=value.typ_vazby"});
            this.MakeField("ixp_sablony");
            this.MakeBoolField("priz_dupli");
            this.MakeSelectField("ixs_zap", Gordic.Prefabs.Select.ginszap(), { model: "model.ixs_zap=value.ixs_zap", dropdown: false })
            this.MakeField("zakon_duvod_gdpr");
            // toto nen� obslou�en� ani v ADM01
            //this.MakeField("ixs_cin"); //this.MakeSelectField("ixs_cin", Gordic.Prefabs.Select.ginsc);
            this.MakeSelectField("plan_zve", Gordic.Prefabs.Select.wflcplz(), { model: "model.plan_zve=value.plan_zve" })
            this.MakeSelectField("priz_fyz", Gordic.Prefabs.Select.sslcpfy() )

            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_od");
            this.MakeField("dat_do");
            this.MakeSelectField("ixs_fsk", Gordic.Prefabs.Select.wflsfsk(), { model: "model.ixs_fsk=value.ixs_fsk", dropdown: false });
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
            //this.MakeField("ixs_typ");
            //this.MakeField("lic");
            //this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            //this.MakeField("arw");
            //this.MakeField("poznamka");
            //this.MakeField("dat_zmena");
            //this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
            //this.MakeField("nazev");
            //this.MakeField("ktg_typ");
            //this.MakeField("popis");
            //this.MakeField("st_utaj_id");
            //this.MakeField("lhuta_vyr");
            //this.MakeField("zkratka");
            //this.MakeField("ixs_ulz");
            //this.MakeField("aktivita_ssl");
            //this.MakeField("spis_pl");
            //this.MakeField("spis_znak");
            //this.MakeField("ofic_nazev");
            //this.MakeField("s_gen_cj");
            //this.MakeField("ixs_esu");
            //this.MakeField("ixs_lpc");
            //this.MakeField("z_int");
            //this.MakeField("cs_nazev");
            //this.MakeSelectField("priz_vycet", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_vycet=value.priz_an" });
            //this.MakeField("ixs_cin");
            //this.MakeField("ixs_typ_opr");
            //this.MakeSelectField("priz_rsp", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_rsp=value.priz_an" });
            //this.MakeSelectField("priz_epk", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_epk=value.priz_an" });
            //this.MakeField("predpl_vec");
            //this.MakeField("typ_vazby");
            //this.MakeField("ixp_sablony");
            //this.MakeSelectField("priz_dupli", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_dupli=value.priz_an" });
            //this.MakeField("zakon_duvod_gdpr");
            //this.MakeField("s_dotaz_irp");
            //this.MakeField("plan_zve");
            //this.MakeSelectField("priz_fyz", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_fyz=value.priz_an" });
            //this.MakeField("ixs_zap");
        }
    }
}
